// Usuários online
(function () {
  'use strict';

  // Variáveis
  const urlApi = urlBase + 'core/acoes/checkout/users_online.php';
  let isLoading = false;

  // Verifica se o usuário possui um token
  function getViewToken() {
    let viewToken = sessionStorage.getItem('lpqv_v_token');
    if (!viewToken) {
      viewToken = generateToken('25');
      sessionStorage.setItem('lpqv_v_token', viewToken);
    }
    return viewToken;
  }

  // Envia as informações do usuário
  function sendUserOnline() {
    if (!isLoading && !previewMode && idleTime < 2) {
      const viewToken = getViewToken();
      $.ajax({
        url: urlApi,
        type: 'POST',
        data: {
          acao: 'users_online',
          store: baseStore,
          token: viewToken,
          landing: baseLanding,
          page: userOnPagParam,
          pag_link: window.location.href,
        },
        beforeSend: function () {
          isLoading = true;
        },
      })
        .done(function (result) {
          isLoading = false;
          //console.log(result);
        })
        .fail(function (jqXHR, textStatus, error) {
          isLoading = false;
          console.log(error);
        });
    }
  }

  // Carrega a primeira vez quando a página é carregada
  $(window).on('load', function () {
    setTimeout(sendUserOnline, 1000);
    const userOnlineInterval = setInterval(() => {
      sendUserOnline();
    }, 60000);
  });

  // Calcula o tempo de inatividade (Minutos)
  let idleTime = 0;
  const idleInterval = setInterval(() => {
    idleTime = idleTime + 0.5;
  }, 30000);
  $(document).on(
    'mousemove keypress scroll touchstart',
    debounce(function () {
      idleTime = 0;
    }, 100),
  );
})();
